export default {
  title: 'Palvelumaksun tuottolaskuri',
  description: 'Arvioi, kuinka paljon palvelumaksu tuottaa kuukaudessa. Luvut päivittyvät kirjoittaessasi.',
  authoritative:
    'Alla oleva prosenttiosuus ja enimmäismaksu ovat asetukset, joita sovelletaan. Keskimääräinen tilausarvo ja kuukausittainen GMV ovat vain arvioita.',
  off_notice:
    'Palvelumaksu on pois käytöstä tässä ravintolassa, joten se ei tuota vielä mitään. Tallenna yllä oleva maksu ottaaksesi sen käyttöön.',
  fields: {
    recommended: 'Suositus: {{value}}',
    aov: {
      label: 'Keskimääräinen tilauksen arvo',
      help: 'Tyypillinen ostoskorin koko verkkotilausjärjestelmässäsi.',
      placeholder: 'esim. 32,50',
    },
    percentage: {
      label: 'Palvelumaksuprosentti',
      help: 'Välillä {{min}} %–{{max}} %.',
    },
    max_amount: {
      label: 'Enimmäismaksu tilausta kohden',
      help: '{{max}} on alustan enimmäismäärä.',
      below_min: 'Enimmäismaksun on oltava vähintään {{min}}.',
    },
    monthly_gmv: {
      label: 'Kuukausittainen GMV',
      help: 'Kuukaudessa käsitelty tilausten kokonaisarvo.',
      placeholder: 'esim. 85000',
    },
  },
  outputs: {
    partner_revenue: 'Arvioitu kuukausitulosi',
    approximate: 'Likimääräinen arvo yllä olevien tietojen perusteella — todellinen tulo vaihtelee.',
    estimate_inputs: 'Perustuu arvioituun tilausarvoosi ja GMV:hen — todellinen tulo vaihtelee.',
    share: 'Tämä on {{share}} % osuutesi kerätystä palvelumaksusta.',
    total_collected: 'Kassalla asiakkailta kerätty palvelumaksu yhteensä',
    total_collected_note: '— asiakkaiden maksama, ei lisätuloa yllä olevan luvun päälle.',
    effective_rate: 'Todellinen maksuprosentti kaikissa tilauksissa',
  },
};
